
import { Component, Input, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { ConnectServerService } from '../../../../services/connect-server.service';
import { PopupDialogService } from '../../../../services/popup-dialog.service';
import { CheckFormValidityService } from '../../../../services/check-form-validity.service';
import { ApiResponse } from '../../../../interfaces/api-response';

@Component({
  selector: 'app-geographic-location',
  imports: [
    MatExpansionModule,
    ReactiveFormsModule
],
  templateUrl: './geographic-location.component.html',
  styleUrl: './geographic-location.component.scss'
})
export class GeographicLocationComponent {
  readonly panelOpenState = signal(false);

  @Input() idarticle: number = 0;
  saved: boolean = false;
  submitted: boolean = false;

  geographicForm: FormGroup;

  constructor(private fb: FormBuilder, private connectServerService: ConnectServerService,
    private popupDialogService: PopupDialogService,
    private checkFormValidityService: CheckFormValidityService) {
    this.geographicForm = this.fb.group({
      specifications: [null, [Validators.required, Validators.maxLength(250)]],

    });
  }
  ngOnInit(): void {
   this.getGeographicInfo();
  }
  private getGeographicInfo() {
    this.connectServerService.getRequest('geographicInfo', { idarticle: this.idarticle })
      .subscribe((val: ApiResponse<{ infoGeographic: any }>) => {
        this.geographicForm.get('specifications')?.setValue(val.data.infoGeographic.specifications);
        this.saved = this.checkFormValidityService.areAllRequiredFieldsFilled(this.geographicForm);
        if(this.saved) {
          this.panelOpenState.set(false);
        }
        else {
          this.panelOpenState.set(true);
        }
      })
  }

  private setGeographicInfo() {
    const formValues = this.geographicForm.getRawValue()
    this.connectServerService.postRequest<ApiResponse<null>>('updateGeographicInfo', {
      infoGeographic: formValues,
      idarticle: this.idarticle,
    }).subscribe(
      (val: ApiResponse<null>) => {
        this.popupDialogService.popupDialog(val);
        this.getGeographicInfo();
      }
    )
  }

  save() {
    this.submitted = true;
    if(this.geographicForm.valid) {
      this.setGeographicInfo();
    }
  }
}
